/*! For license information please see scripts.js.LICENSE.txt */
!function (t, e) {
  "object" == typeof exports && "object" == typeof module ? module.exports = e(require("array-flat-polyfill"), require("react"), require("react-dom"), require("redux")) : "function" == typeof define && define.amd ? define([,,,], e) : "object" == typeof exports ? exports.AblyUi = e(require("array-flat-polyfill"), require("react"), require("react-dom"), require("redux")) : (t.AblyUi = t.AblyUi || {}, t.AblyUi.Core = e(t[void 0], t[void 0], t[void 0], t[void 0]));
}(this, (t, e, r, n) => (() => {
  var o = {
      670: e => {
        "use strict";

        e.exports = t;
      },
      225: t => {
        "use strict";

        t.exports = e;
      },
      779: t => {
        "use strict";

        t.exports = r;
      },
      293: t => {
        "use strict";

        t.exports = n;
      },
      61: (t, e, r) => {
        var n = r(698).default;
        function o() {
          "use strict";

          t.exports = o = function () {
            return r;
          }, t.exports.__esModule = !0, t.exports.default = t.exports;
          var e,
            r = {},
            i = Object.prototype,
            a = i.hasOwnProperty,
            c = Object.defineProperty || function (t, e, r) {
              t[e] = r.value;
            },
            u = "function" == typeof Symbol ? Symbol : {},
            s = u.iterator || "@@iterator",
            l = u.asyncIterator || "@@asyncIterator",
            f = u.toStringTag || "@@toStringTag";
          function p(t, e, r) {
            return Object.defineProperty(t, e, {
              value: r,
              enumerable: !0,
              configurable: !0,
              writable: !0
            }), t[e];
          }
          try {
            p({}, "");
          } catch (e) {
            p = function (t, e, r) {
              return t[e] = r;
            };
          }
          function d(t, e, r, n) {
            var o = e && e.prototype instanceof w ? e : w,
              i = Object.create(o.prototype),
              a = new q(n || []);
            return c(i, "_invoke", {
              value: k(t, r, a)
            }), i;
          }
          function h(t, e, r) {
            try {
              return {
                type: "normal",
                arg: t.call(e, r)
              };
            } catch (t) {
              return {
                type: "throw",
                arg: t
              };
            }
          }
          r.wrap = d;
          var y = "suspendedStart",
            v = "suspendedYield",
            g = "executing",
            b = "completed",
            m = {};
          function w() {}
          function x() {}
          function O() {}
          var j = {};
          p(j, s, function () {
            return this;
          });
          var S = Object.getPrototypeOf,
            P = S && S(S(R([])));
          P && P !== i && a.call(P, s) && (j = P);
          var E = O.prototype = w.prototype = Object.create(j);
          function L(t) {
            ["next", "throw", "return"].forEach(function (e) {
              p(t, e, function (t) {
                return this._invoke(e, t);
              });
            });
          }
          function _(t, e) {
            function r(o, i, c, u) {
              var s = h(t[o], t, i);
              if ("throw" !== s.type) {
                var l = s.arg,
                  f = l.value;
                return f && "object" == n(f) && a.call(f, "__await") ? e.resolve(f.__await).then(function (t) {
                  r("next", t, c, u);
                }, function (t) {
                  r("throw", t, c, u);
                }) : e.resolve(f).then(function (t) {
                  l.value = t, c(l);
                }, function (t) {
                  return r("throw", t, c, u);
                });
              }
              u(s.arg);
            }
            var o;
            c(this, "_invoke", {
              value: function (t, n) {
                function i() {
                  return new e(function (e, o) {
                    r(t, n, e, o);
                  });
                }
                return o = o ? o.then(i, i) : i();
              }
            });
          }
          function k(t, r, n) {
            var o = y;
            return function (i, a) {
              if (o === g) throw new Error("Generator is already running");
              if (o === b) {
                if ("throw" === i) throw a;
                return {
                  value: e,
                  done: !0
                };
              }
              for (n.method = i, n.arg = a;;) {
                var c = n.delegate;
                if (c) {
                  var u = A(c, n);
                  if (u) {
                    if (u === m) continue;
                    return u;
                  }
                }
                if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) {
                  if (o === y) throw o = b, n.arg;
                  n.dispatchException(n.arg);
                } else "return" === n.method && n.abrupt("return", n.arg);
                o = g;
                var s = h(t, r, n);
                if ("normal" === s.type) {
                  if (o = n.done ? b : v, s.arg === m) continue;
                  return {
                    value: s.arg,
                    done: n.done
                  };
                }
                "throw" === s.type && (o = b, n.method = "throw", n.arg = s.arg);
              }
            };
          }
          function A(t, r) {
            var n = r.method,
              o = t.iterator[n];
            if (o === e) return r.delegate = null, "throw" === n && t.iterator.return && (r.method = "return", r.arg = e, A(t, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), m;
            var i = h(o, t.iterator, r.arg);
            if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, m;
            var a = i.arg;
            return a ? a.done ? (r[t.resultName] = a.value, r.next = t.nextLoc, "return" !== r.method && (r.method = "next", r.arg = e), r.delegate = null, m) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, m);
          }
          function D(t) {
            var e = {
              tryLoc: t[0]
            };
            1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
          }
          function T(t) {
            var e = t.completion || {};
            e.type = "normal", delete e.arg, t.completion = e;
          }
          function q(t) {
            this.tryEntries = [{
              tryLoc: "root"
            }], t.forEach(D, this), this.reset(!0);
          }
          function R(t) {
            if (t || "" === t) {
              var r = t[s];
              if (r) return r.call(t);
              if ("function" == typeof t.next) return t;
              if (!isNaN(t.length)) {
                var o = -1,
                  i = function r() {
                    for (; ++o < t.length;) if (a.call(t, o)) return r.value = t[o], r.done = !1, r;
                    return r.value = e, r.done = !0, r;
                  };
                return i.next = i;
              }
            }
            throw new TypeError(n(t) + " is not iterable");
          }
          return x.prototype = O, c(E, "constructor", {
            value: O,
            configurable: !0
          }), c(O, "constructor", {
            value: x,
            configurable: !0
          }), x.displayName = p(O, f, "GeneratorFunction"), r.isGeneratorFunction = function (t) {
            var e = "function" == typeof t && t.constructor;
            return !!e && (e === x || "GeneratorFunction" === (e.displayName || e.name));
          }, r.mark = function (t) {
            return Object.setPrototypeOf ? Object.setPrototypeOf(t, O) : (t.__proto__ = O, p(t, f, "GeneratorFunction")), t.prototype = Object.create(E), t;
          }, r.awrap = function (t) {
            return {
              __await: t
            };
          }, L(_.prototype), p(_.prototype, l, function () {
            return this;
          }), r.AsyncIterator = _, r.async = function (t, e, n, o, i) {
            void 0 === i && (i = Promise);
            var a = new _(d(t, e, n, o), i);
            return r.isGeneratorFunction(e) ? a : a.next().then(function (t) {
              return t.done ? t.value : a.next();
            });
          }, L(E), p(E, f, "Generator"), p(E, s, function () {
            return this;
          }), p(E, "toString", function () {
            return "[object Generator]";
          }), r.keys = function (t) {
            var e = Object(t),
              r = [];
            for (var n in e) r.push(n);
            return r.reverse(), function t() {
              for (; r.length;) {
                var n = r.pop();
                if (n in e) return t.value = n, t.done = !1, t;
              }
              return t.done = !0, t;
            };
          }, r.values = R, q.prototype = {
            constructor: q,
            reset: function (t) {
              if (this.prev = 0, this.next = 0, this.sent = this._sent = e, this.done = !1, this.delegate = null, this.method = "next", this.arg = e, this.tryEntries.forEach(T), !t) for (var r in this) "t" === r.charAt(0) && a.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = e);
            },
            stop: function () {
              this.done = !0;
              var t = this.tryEntries[0].completion;
              if ("throw" === t.type) throw t.arg;
              return this.rval;
            },
            dispatchException: function (t) {
              if (this.done) throw t;
              var r = this;
              function n(n, o) {
                return c.type = "throw", c.arg = t, r.next = n, o && (r.method = "next", r.arg = e), !!o;
              }
              for (var o = this.tryEntries.length - 1; o >= 0; --o) {
                var i = this.tryEntries[o],
                  c = i.completion;
                if ("root" === i.tryLoc) return n("end");
                if (i.tryLoc <= this.prev) {
                  var u = a.call(i, "catchLoc"),
                    s = a.call(i, "finallyLoc");
                  if (u && s) {
                    if (this.prev < i.catchLoc) return n(i.catchLoc, !0);
                    if (this.prev < i.finallyLoc) return n(i.finallyLoc);
                  } else if (u) {
                    if (this.prev < i.catchLoc) return n(i.catchLoc, !0);
                  } else {
                    if (!s) throw new Error("try statement without catch or finally");
                    if (this.prev < i.finallyLoc) return n(i.finallyLoc);
                  }
                }
              }
            },
            abrupt: function (t, e) {
              for (var r = this.tryEntries.length - 1; r >= 0; --r) {
                var n = this.tryEntries[r];
                if (n.tryLoc <= this.prev && a.call(n, "finallyLoc") && this.prev < n.finallyLoc) {
                  var o = n;
                  break;
                }
              }
              o && ("break" === t || "continue" === t) && o.tryLoc <= e && e <= o.finallyLoc && (o = null);
              var i = o ? o.completion : {};
              return i.type = t, i.arg = e, o ? (this.method = "next", this.next = o.finallyLoc, m) : this.complete(i);
            },
            complete: function (t, e) {
              if ("throw" === t.type) throw t.arg;
              return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), m;
            },
            finish: function (t) {
              for (var e = this.tryEntries.length - 1; e >= 0; --e) {
                var r = this.tryEntries[e];
                if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), T(r), m;
              }
            },
            catch: function (t) {
              for (var e = this.tryEntries.length - 1; e >= 0; --e) {
                var r = this.tryEntries[e];
                if (r.tryLoc === t) {
                  var n = r.completion;
                  if ("throw" === n.type) {
                    var o = n.arg;
                    T(r);
                  }
                  return o;
                }
              }
              throw new Error("illegal catch attempt");
            },
            delegateYield: function (t, r, n) {
              return this.delegate = {
                iterator: R(t),
                resultName: r,
                nextLoc: n
              }, "next" === this.method && (this.arg = e), m;
            }
          }, r;
        }
        t.exports = o, t.exports.__esModule = !0, t.exports.default = t.exports;
      },
      698: t => {
        function e(r) {
          return t.exports = e = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
            return typeof t;
          } : function (t) {
            return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
          }, t.exports.__esModule = !0, t.exports.default = t.exports, e(r);
        }
        t.exports = e, t.exports.__esModule = !0, t.exports.default = t.exports;
      },
      687: (t, e, r) => {
        var n = r(61)();
        t.exports = n;
        try {
          regeneratorRuntime = n;
        } catch (t) {
          "object" == typeof globalThis ? globalThis.regeneratorRuntime = n : Function("r", "regeneratorRuntime = r")(n);
        }
      }
    },
    i = {};
  function a(t) {
    var e = i[t];
    if (void 0 !== e) return e.exports;
    var r = i[t] = {
      exports: {}
    };
    return o[t](r, r.exports, a), r.exports;
  }
  a.n = t => {
    var e = t && t.__esModule ? () => t.default : () => t;
    return a.d(e, {
      a: e
    }), e;
  }, a.d = (t, e) => {
    for (var r in e) a.o(e, r) && !a.o(t, r) && Object.defineProperty(t, r, {
      enumerable: !0,
      get: e[r]
    });
  }, a.o = (t, e) => Object.prototype.hasOwnProperty.call(t, e), a.r = t => {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(t, "__esModule", {
      value: !0
    });
  };
  var c = {};
  return (() => {
    "use strict";

    a.r(c), a.d(c, {
      attachStoreToWindow: () => v,
      connectState: () => b,
      createRemoteDataStore: () => m,
      fetchBlogPosts: () => L,
      fetchSessionData: () => N,
      getRemoteDataStore: () => g,
      loadSprites: () => u,
      queryId: () => s,
      queryIdAll: () => l,
      reactRenderer: () => i,
      reducerBlogPosts: () => A,
      reducerSessionData: () => C,
      renderComponent: () => o,
      selectRecentBlogPosts: () => D,
      selectSessionData: () => F,
      toggleChatWidget: () => h
    }), a(670);
    var t = a(225),
      e = a.n(t),
      r = a(779),
      n = a.n(r),
      o = function (t, r, o) {
        return n().render(e().createElement(t, r), o);
      };
    function i(t) {
      var r = document.querySelectorAll("[data-react]");
      Array.from(r).forEach(function (r) {
        var o = r.getAttribute("data-react"),
          i = t[o];
        if (i) {
          var a = r.getAttribute("data-react-props"),
            c = a && JSON.parse(a || {});
          n().render(e().createElement(i, c), r), r.removeAttribute("data-react"), r.removeAttribute("data-react-props");
        }
      });
    }
    const u = function (t) {
      fetch(t).then(function (t) {
        return t.text();
      }).then(function (t) {
        var e = document.createElement("div");
        e.style.display = "none", e.innerHTML = t, document.body.appendChild(e);
      }).catch(function (t) {
        return console.error(t);
      });
    };
    var s = function (t) {
        return (arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : document).querySelector("[data-id=".concat(t, "]"));
      },
      l = function (t) {
        return (arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : document).querySelectorAll("[data-id=".concat(t, "]"));
      };
    function f(t, e) {
      t.disabled = !0, t.innerText = e;
    }
    var p = 100,
      d = 30;
    function h() {
      var t = (arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}).dataId,
        e = s(t),
        r = s("open-chat-widget", e),
        n = r.dataset.enabledLabel,
        o = r.dataset.disabledLabel;
      if (t && e) {
        var i,
          a = s("open-chat-widget", e);
        return f(a, o), function t(e) {
          var r,
            o,
            c,
            u,
            s = null === (r = window) || void 0 === r || null === (o = r.HubSpotConversations) || void 0 === o ? void 0 : o.widget,
            l = document.querySelector("#hubspot-messages-iframe-container");
          i = function (t) {
            t.preventDefault(), s.open();
          }, s && l ? (a.addEventListener("click", i), u = n, (c = a).disabled = !1, c.innerText = u) : --d && setTimeout(function () {
            return t(p);
          }, e);
        }(0), function () {
          f(a, o), a.removeEventListener("click", i);
        };
      }
    }
    var y = a(293),
      v = function (t) {
        window.AblyUi = window.AblyUi || {}, window.AblyUi.RemoteDataStore = t;
      },
      g = function () {
        if (!window.AblyUi.RemoteDataStore) throw new Error("Remote store was called before one was created");
        return window.AblyUi.RemoteDataStore;
      },
      b = function (t, e) {
        var r = g(),
          n = t(r);
        r.subscribe(function () {
          var o = t(r);
          o !== n && (n = o, e(o));
        });
      },
      m = function (t) {
        return (0, y.createStore)((0, y.combineReducers)(t));
      },
      w = a(687),
      x = a.n(w),
      O = function (t) {
        return t && t.includes("application/json");
      };
    function j(t, e) {
      var r = Object.keys(t);
      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(t);
        e && (n = n.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), r.push.apply(r, n);
      }
      return r;
    }
    function S(t) {
      for (var e = 1; e < arguments.length; e++) {
        var r = null != arguments[e] ? arguments[e] : {};
        e % 2 ? j(Object(r), !0).forEach(function (e) {
          P(t, e, r[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : j(Object(r)).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
        });
      }
      return t;
    }
    function P(t, e, r) {
      return e in t ? Object.defineProperty(t, e, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : t[e] = r, t;
    }
    function E(t, e, r, n, o, i, a) {
      try {
        var c = t[i](a),
          u = c.value;
      } catch (t) {
        return void r(t);
      }
      c.done ? e(u) : Promise.resolve(u).then(n, o);
    }
    var L = function () {
        var t,
          e = (t = x().mark(function t(e, r) {
            var n, o;
            return x().wrap(function (t) {
              for (;;) switch (t.prev = t.next) {
                case 0:
                  if (t.prev = 0, r) {
                    t.next = 4;
                    break;
                  }
                  return console.log('Skipping fetching blog posts, invalid blogUrl: "'.concat(r, '"')), t.abrupt("return");
                case 4:
                  return t.next = 6, fetch(r);
                case 6:
                  if (n = t.sent, !O(n.headers.get("content-type"))) {
                    t.next = 14;
                    break;
                  }
                  return t.next = 10, n.json();
                case 10:
                  o = t.sent, e.dispatch({
                    type: "blog/loaded",
                    payload: o
                  }), t.next = 15;
                  break;
                case 14:
                  throw new Error("Blog posts url is not serving json");
                case 15:
                  t.next = 20;
                  break;
                case 17:
                  t.prev = 17, t.t0 = t.catch(0), console.warn("Could not fetch blog posts due to error:", t.t0);
                case 20:
                case "end":
                  return t.stop();
              }
            }, t, null, [[0, 17]]);
          }), function () {
            var e = this,
              r = arguments;
            return new Promise(function (n, o) {
              var i = t.apply(e, r);
              function a(t) {
                E(i, n, o, a, c, "next", t);
              }
              function c(t) {
                E(i, n, o, a, c, "throw", t);
              }
              a(void 0);
            });
          });
        return function (t, r) {
          return e.apply(this, arguments);
        };
      }(),
      _ = {
        recent: null
      },
      k = "blogPosts",
      A = P({}, k, function () {
        var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : _,
          e = arguments.length > 1 ? arguments[1] : void 0;
        return "blog/loaded" === e.type ? S(S({}, t), {}, {
          recent: e.payload
        }) : t;
      }),
      D = function (t) {
        var e;
        return null === (e = t.getState()[k]) || void 0 === e ? void 0 : e.recent;
      };
    function T(t, e) {
      var r = Object.keys(t);
      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(t);
        e && (n = n.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), r.push.apply(r, n);
      }
      return r;
    }
    function q(t) {
      for (var e = 1; e < arguments.length; e++) {
        var r = null != arguments[e] ? arguments[e] : {};
        e % 2 ? T(Object(r), !0).forEach(function (e) {
          R(t, e, r[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : T(Object(r)).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
        });
      }
      return t;
    }
    function R(t, e, r) {
      return e in t ? Object.defineProperty(t, e, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : t[e] = r, t;
    }
    function U(t, e, r, n, o, i, a) {
      try {
        var c = t[i](a),
          u = c.value;
      } catch (t) {
        return void r(t);
      }
      c.done ? e(u) : Promise.resolve(u).then(n, o);
    }
    var N = function () {
        var t,
          e = (t = x().mark(function t(e, r) {
            var n, o, i;
            return x().wrap(function (t) {
              for (;;) switch (t.prev = t.next) {
                case 0:
                  if (n = function () {
                    var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                    return e.dispatch({
                      type: "session/loaded",
                      payload: t
                    });
                  }, t.prev = 1, r) {
                    t.next = 6;
                    break;
                  }
                  return console.log('Skipping fetching session, invalid sessionUrl: "'.concat(r, '"')), n(), t.abrupt("return");
                case 6:
                  return t.next = 8, fetch(r, {
                    cache: "no-cache"
                  });
                case 8:
                  if (o = t.sent, O(o.headers.get("content-type"))) {
                    t.next = 12;
                    break;
                  }
                  throw new Error("Session endpoint is not serving json");
                case 12:
                  return t.next = 14, o.json();
                case 14:
                  "not-found" === (i = t.sent).error ? n() : n(i), t.next = 22;
                  break;
                case 18:
                  t.prev = 18, t.t0 = t.catch(1), n(), console.warn("Could not fetch session data due to error:", t.t0);
                case 22:
                case "end":
                  return t.stop();
              }
            }, t, null, [[1, 18]]);
          }), function () {
            var e = this,
              r = arguments;
            return new Promise(function (n, o) {
              var i = t.apply(e, r);
              function a(t) {
                U(i, n, o, a, c, "next", t);
              }
              function c(t) {
                U(i, n, o, a, c, "throw", t);
              }
              a(void 0);
            });
          });
        return function (t, r) {
          return e.apply(this, arguments);
        };
      }(),
      G = {
        data: null
      },
      M = "session",
      C = R({}, M, function () {
        var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : G,
          e = arguments.length > 1 ? arguments[1] : void 0;
        return "session/loaded" === e.type ? q(q({}, t), {}, {
          data: e.payload
        }) : t;
      }),
      F = function (t) {
        var e;
        return null === (e = t.getState()[M]) || void 0 === e ? void 0 : e.data;
      };
  })(), c;
})());